<template>
  <!-- This div wrapper was created so :deep style can be applied -->
  <div>
    <Dropdown
      :model-value="dropdownValue"
      name="sort-by"
      label="Sort By"
      :options="sortByOptions"
      @update:modelValue="dropdownUpdate"
    />
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import useSortByCriteria from '../composables/useSortByCriteria';

const Dropdown = defineAsyncComponent(() => import('@atomic-ui/dropdown/Dropdown'));

const {
  dropdownValue,
  dropdownUpdate,
  sortByOptions,
} = useSortByCriteria();

</script>

<style lang="scss" scoped>
:deep(.select-container) {
  margin-top: 5px;
  margin-bottom: 0;
    select {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
:deep(.select-container) {
    select {
    padding-top: 11px;
    padding-bottom: 11px;
  }
}
</style>
